import { RefObject } from 'react';

export enum SelectType {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

export enum SelectSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum SelectListPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface OnChangeProps {
  name: string;
  values: SelectItemProps[];
}

export interface SelectItemProps {
  name: string;
  description?: string;
  suffix?: string;
  value: string | number;
  highlight?: React.JSX.Element;
  hidden?: boolean;
}

export interface OnSelectChange {
  target: {
    name: string;
    value: string | number | string[];
    suffix?: string;
  };
}

export interface SelectProps {
  mode?: SelectType;
  value?: string | number | string[];
  disabled?: boolean;
  list?: SelectItemProps[];
  onChange?: (e: OnSelectChange) => void;
  onSearch?: (search: string) => void;
  placeholder?: string;
  title?: string;
  className?: string;
  name?: string;
  isOptionsListVisible?: boolean;
  hideSelectedItems?: boolean;
  size?: SelectSize;
  borderless?: boolean;
  selectWrapperClassName?: string;
  selectListPosition?: SelectListPosition;
  fullWidth?: boolean;
  error?: string;
  emptyContentButton?: React.JSX.Element;
  withoutSelectedValues?: boolean;
  isLoading?: boolean;
  contentButtons?: React.JSX.Element;
  tabIndex?: number;
  yearSelector?: boolean;
  withClearButton?: boolean;
  withButtonInTitle?: boolean;
  titleButtonText?: string;
  onTitleButtonClick?: () => void;
  selectedValuesList?: SelectItemProps[];
  withValuesScroll?: boolean;
  hintText?: string;
  withInfiniteScroll?: boolean;
  onInfinateScroll?: () => void;
  hasNextPage?: boolean;
  nextPageIsLoading?: boolean;
  optionListClassName?: string;
  withSuffix?: boolean;
  withoutSelectedValue?: boolean;
  selectedMultipleList?: { name: string; value: string }[];
}

export interface UseFilteredListProps {
  list: SelectItemProps[];
  searchQuery: string;
  isOptionsListVisible: boolean;
  autocompleteMultiple?: boolean;
}

export interface SelectedFieldProps {
  selectValues: string[];
  mode?: SelectType;
  list: SelectItemProps[];
  removeItem?: (item: string | number) => void;
  size?: SelectSize;
  withValuesScroll?: boolean;
  withSuffix?: boolean;
  disabled?: boolean;
}

export interface SelectComponentTypes {
  list: SelectItemProps[];
  handleSelectValue: (item: SelectItemProps) => void;
  selectListPosition: SelectListPosition;
  selectValues?: string[];
  emptyContentButton?: React.JSX.Element;
  isLoading?: boolean;
  ulRef?: RefObject<HTMLUListElement | null>;
  onScroll: (e: any) => void;
  mode?: SelectType;
  nextPageIsLoading?: boolean;
  onSearch?: (text: string) => void;
}

export interface BacklightTextTypes {
  searchText?: string[] | string;
  text: string;
  className?: string;
}
